import { logoutEpic } from '@clearscore/epic.session';
import { stageRedirectEpic } from '@clearscore/epic.stage-redirect';
import { marketConfigEpic } from '@clearscore/epic.market-config';
import trackingEpic from '@clearscore/epic.tracking';
import { trackingEpic as webappTrackingEpic } from '@clearscore/helpers.webapp-tracking';

import gdprRedirectEpic from './epics/gdpr-redirect';
import implicitTermsEpic from './epics/implicit-terms-and-conditions.epic';
import requestFailedEpic from './epics/request-failed.epic';
import reportNotFoundEpic from './epics/report-not-found.epic';
import trackingConfig from './tracking-config';

export default {
    logoutEpic,
    stageRedirectEpic,
    gdprRedirectEpic,
    trackingEpic: webappTrackingEpic,
    marketConfigEpic,
    implicitTermsEpic,
    requestFailedEpic,
    reportNotFoundEpic,
    tracking: trackingEpic(trackingConfig),
};
